<mat-card class="p-0">
    <form [formGroup]="doctoCForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
            <!-- Botões de Ação Superior -->
            <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px" class="top-actions-bar">
                <button mat-raised-button color="accent" (click)="close()">
                    <mat-icon>arrow_back</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
                </button>
                <button mat-raised-button color="primary" [matTooltip]="'Salvar Lançamento'"
                    (click)="save(false, false); $event.preventDefault()">
                    <mat-icon>save</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
                </button>
                <button mat-raised-button color="primary" [matTooltip]="'Copiar Lançamento (Idem)'"
                    (click)="idemLcto(); $event.preventDefault()" [disabled]="!podeIdem">
                    <mat-icon>file_copy</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">Idem</ng-container>
                </button>
                <!-- Botões Itens e Parcelas restaurados para telas não-mobile -->
                <button mat-raised-button color="primary" (click)="openItensPopUp(doctoCForm)"
                    *ngIf="!layoutConf.isMobile">
                    <mat-icon>format_list_numbered</mat-icon>
                    {{ "LCTO_ITENS" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="openParcelas(doctoCForm)"
                    *ngIf="!layoutConf.isMobile">
                    <mat-icon>payments</mat-icon>
                    {{ "PARCELAS" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="previa(); $event.preventDefault();"
                    *ngIf="!layoutConf.isMobile && this.dfe"
                    [matTooltip]="isNfseDocto ? 'Gera o PDF do DANFSe a partir do DPS (não transmite)' : ''">
                    <mat-icon>assignment_turned_in</mat-icon> {{ rotuloDfe }} {{ "PREVIA" | translate }}
                </button>
                <button mat-raised-button color="primary" (click)="autoriza(); $event.preventDefault();"
                    *ngIf="!layoutConf.isMobile && this.dfe">
                    <mat-icon>assignment_turned_in</mat-icon> {{ rotuloDfe }} {{ "AUTORIZA" | translate }}
                </button>
                <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" aria-label="Mais Opções">
                    <mat-icon>more_vert</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">Mais Opções</ng-container>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openItensPopUp(doctoCForm); $event.preventDefault();"
                        *ngIf="layoutConf.isMobile">
                        <mat-icon>format_list_numbered</mat-icon> {{ "LCTO_ITENS" | translate }}
                    </button>
                    <button mat-menu-item (click)="openParcelas(doctoCForm); $event.preventDefault();"
                        *ngIf="layoutConf.isMobile">
                        <mat-icon>payments</mat-icon> {{ "PARCELAS" | translate }}
                    </button>
                    <button mat-menu-item (click)="openAnexoUploadListPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>attachment</mat-icon> Anexos
                    </button>
                    <button mat-menu-item
                        (click)="openAnexoUploadListPopUpCadastro(doctoCForm); $event.preventDefault();">
                        <mat-icon>attachment</mat-icon> Anexo(s) Cadastrais
                    </button>
                    <button mat-menu-item (click)="openTotaisPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>request_quote</mat-icon> {{ "LCTO_TOTAIS" | translate }}
                    </button>
                    <!-- Marketplace: o proprio lancamento e o documento da operacao. Remessa leva
                         produto e quantidade ao canal; o de precos so reajusta o que ja esta no ar. -->
                    <button mat-menu-item [matMenuTriggerFor]="marketplaceMenu">
                        <mat-icon>store</mat-icon> Marketplace
                    </button>
                    <mat-menu #marketplaceMenu="matMenu">
                        <button mat-menu-item (click)="publicarNoMarketplace(); $event.preventDefault();">
                            <mat-icon>cloud_upload</mat-icon> Publicar itens no Mercado Livre
                        </button>
                        <button mat-menu-item (click)="atualizarPrecosNoMarketplace(); $event.preventDefault();">
                            <mat-icon>sell</mat-icon> Atualizar preços no Mercado Livre
                        </button>
                    </mat-menu>
                    <!-- <button mat-menu-item (click)="print(1); $event.preventDefault();">
                        <mat-icon>print</mat-icon> Formulário 1
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario1Menu">
                        <mat-icon>description</mat-icon> Formulário 1
                    </button>
                    <!-- Submenu para opções de envio via WhatsApp -->
                    <mat-menu #formulario1Menu="matMenu">
                        <button mat-menu-item (click)="print(1); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(1)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                    <!-- <button mat-menu-item (click)="print(2); $event.preventDefault();">
                       <mat-icon>print</mat-icon> Formulário 2
                     </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario2Menu">
                        <mat-icon>description</mat-icon> Formulário 2
                    </button>
                    <mat-menu #formulario2Menu="matMenu">
                        <button mat-menu-item (click)="print(2); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(2)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                    <!-- <button mat-menu-item (click)="print(3); $event.preventDefault();">
                    <mat-icon>print</mat-icon> Formulário 3
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="formulario3Menu">
                        <mat-icon>description</mat-icon> Formulário 3
                    </button>
                    <mat-menu #formulario3Menu="matMenu">
                        <button mat-menu-item (click)="print(3); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(3)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>
                 
                    <!-- <button mat-raised-button color="primary" (click)="previa(); $event.preventDefault();"
                        *ngIf="!layoutConf.isMobile && this.dfe">
                        <mat-icon>assignment_turned_in</mat-icon> DF-e {{ "PREVIA" | translate }}
                    </button> -->
                    <button mat-menu-item [matMenuTriggerFor]="previaMenu">
                        <mat-icon>description</mat-icon> Prévia
                    </button>
                    <mat-menu #previaMenu="matMenu">
                        <button mat-menu-item (click)="previa(); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item *ngIf="isNfseDocto"
                            (click)="previaNfse(); $event.preventDefault();"
                            matTooltip="Baixa o XML do DPS para conferência (não transmite)">
                            <mat-icon>code</mat-icon> XML do DPS
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData('previa')); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>

                    <!-- <button mat-menu-item (click)="print(0); $event.preventDefault();">
                        <mat-icon>print</mat-icon> DF-e Imprimir
                    </button> -->
                    <!-- NF-e/NFC-e imprimem o DANFE; a NFS-e imprime o DANFSe (mesmo endpoint,
                         formId 0 — o backend escolhe o formulário pela diretiva). -->
                    <button mat-menu-item [matMenuTriggerFor]="dfeImprimirMenu">
                        <mat-icon>description</mat-icon> {{ rotuloDfe }} Imprimir
                    </button>
                    <mat-menu #dfeImprimirMenu="matMenu">
                        <button mat-menu-item (click)="print(0); $event.preventDefault();">
                            <mat-icon>print</mat-icon> Imprimir
                        </button>
                        <button mat-menu-item class="whatsapp-dark"
                            (click)="openWhatsapp(getWhatsappInitialData(0)); $event.preventDefault();">
                            <mat-icon svgIcon="whatsapp"></mat-icon> Enviar WhatsApp
                        </button>
                    </mat-menu>

                    <button mat-menu-item color="primary" (click)="autoriza(); $event.preventDefault();">
                        <mat-icon>assignment_turned_in</mat-icon> {{ rotuloDfe }} {{ "AUTORIZA" | translate }}
                    </button>
                    <button mat-menu-item color="warn" (click)="cancela(); $event.preventDefault();">
                        <mat-icon>cancel_presentation</mat-icon> {{ rotuloDfe }} {{ "CANCELAR_NF" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="isNfseDocto" (click)="consultaNfse(); $event.preventDefault();">
                        <mat-icon>fact_check</mat-icon> Consultar NFS-e
                    </button>
                    <button mat-menu-item *ngIf="!isNfseDocto" (click)="consultarNF(); $event.preventDefault();">
                        <mat-icon>search</mat-icon> DF-e Consultar
                    </button>
                    <!-- Vale para a NFS-e também: o XML autorizado passou a ser gravado em
                         nfexmldistribuicao e os anexos do e-mail (XML + DANFSe) saem do mesmo fluxo. -->
                    <button mat-menu-item (click)="enviaEmail(); $event.preventDefault();">
                        <mat-icon>send</mat-icon> {{ rotuloDfe }} Enviar e-mail
                    </button>
                    <!-- Transporte, dados de NF-e, doctos referenciados e CC-e não se aplicam à NFS-e. -->
                    <button mat-menu-item *ngIf="!isNfseDocto"
                        (click)="openTranspVolumes(doctoCForm); $event.preventDefault();">
                        <mat-icon>directions_bus</mat-icon> {{ "TRANSP_VOLUMES" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isNfseDocto"
                        (click)="openDadosNfe(doctoCForm); $event.preventDefault();">
                        <mat-icon>receipt</mat-icon> {{ "DADOS_NFE" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isNfseDocto"
                        (click)="openDoctosRefPopUp(doctoCForm); $event.preventDefault();">
                        <mat-icon>description</mat-icon> {{ "DOCTOS_REF" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isNfseDocto"
                        (click)="openCartaCorrecao(doctoCForm); $event.preventDefault();">
                        <mat-icon>description</mat-icon> {{ "CARTA_CORRECAO" | translate }}
                    </button>
                </mat-menu>
            </div>

            <!-- Conteúdo Principal -->
            <div fxFlex="100">
                <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="tab-content">
                    <!-- Dados Básicos -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>{{ rotuloDocumento }} {{ getControleLctoFormatado() }} - Dados Básicos</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Emissão</mat-label>
                                        <input matInput [matDatepicker]="picker1"
                                            [formControl]="doctoCForm.controls['emissao']">
                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1 startView="month"></mat-datepicker>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['emissao'].hasError('required') && doctoCForm.controls['emissao'].touched">
                                            Emissão é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Data entrada/saída</mat-label>
                                        <input matInput [matDatepicker]="picker2"
                                            [formControl]="doctoCForm.controls['dataentradasaida']">
                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2 startView="month"></mat-datepicker>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['dataentradasaida'].hasError('required') && doctoCForm.controls['dataentradasaida'].touched">
                                            Data entrada/saída é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Transação</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatTransacao']"
                                            (selectionChange)="onSelectionChangeFatTransacao($event)"
                                            (openedChange)="onSelectOpenedChange('searchTransacao', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchTransacao']"
                                                    placeholderLabel="Pesquisar Transação"
                                                    noEntriesFoundLabel="Transação não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let transacao of (filteredTransacoes | async) || fatTransacoes" [value]="transacao">
                                                {{ transacao?.codigo?.toString().padStart(5, '0') + " - " +
                                                transacao?.descricao?.trim() }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatTransacao'].hasError('required') && doctoCForm.controls['fatTransacao'].touched">
                                            Transação é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="10" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input [matAutocomplete]="autoSerie" matInput type="text"
                                            formControlName="serie" placeholder="Série" readonly>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['serie'].hasError('required') && doctoCForm.controls['serie'].touched">
                                            Série é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-autocomplete #autoSerie="matAutocomplete" [displayWith]="displayFnSerie"
                                        (optionSelected)="onSelectionChangeSerie($event)">
                                        <mat-option *ngIf="isLoadingSerie" class="is-loading">
                                            <mat-spinner diameter="30"></mat-spinner>
                                        </mat-option>
                                        <ng-container *ngIf="!isLoadingSerie">
                                            <mat-option *ngFor="let d of series" [value]="d">
                                                {{ d?.codigo + " - " + d?.descricao }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-autocomplete>
                                </div>
                                <div fxFlex="7" fxFlex.lt-md="100">
                                    <!-- Sequencial da série: vazio, o backend numera ao gravar (maior nº da série + 1).
                                         Pode ser alterado até o documento ser autorizado/cancelado/denegado. -->
                                    <mat-form-field appearance="outline" class="full-width"
                                        [matTooltip]="numeroDoctoTooltip">
                                        <mat-label>N° Docto</mat-label>
                                        <input matInput type="number" formControlName="numeroDocto"
                                            [readonly]="numeroDoctoBloqueado" placeholder="Gerado ao salvar"
                                            (focus)="$event.target.select()">
                                        <mat-icon matSuffix *ngIf="numeroDoctoBloqueado">lock</mat-icon>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['numeroDocto'].hasError('required') && doctoCForm.controls['numeroDocto'].touched">
                                            N° Docto é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="30" fxFlex.lt-md="100" fxLayout="column" fxLayoutAlign="end end"
                                    style="text-align: right;">
                                    <span class="status-highlight" style="margin-bottom: 8px;">
                                        <strong>Status:</strong> {{ (lcto?.statuslcto ?? "000") + " - " +
                                        (lcto?.statusDesc ?? "NENHUM STATUS ENCONTRADO")}}
                                    </span>
                                    <h1 *ngIf="!layoutConf.isMobile" style="margin: 0;">TOTAL: {{
                                        doctoCForm.controls['valortotalDocto'].value | currency:'BRL' }}</h1>
                                    <h3 *ngIf="layoutConf.isMobile" style="margin: 0;">TOTAL: {{
                                        doctoCForm.controls['valortotalDocto'].value | currency:'BRL' }}</h3>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Destinatário -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Destinatário (Cliente/Fornecedor/Tomador de Serviço)</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="40" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Destinatário</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadCadastro']"
                                            (selectionChange)="onSelectionChangeDestinatario($event)"
                                            (openedChange)="onSelectOpenedChange('searchDestinatario', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchDestinatario']"
                                                    placeholderLabel="Pesquisar Destinatário"
                                                    noEntriesFoundLabel="Destinatário não encontrado"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let d of filteredDestinatarios | async" [value]="d">
                                                {{ d?.codigo?.toString()?.padStart(9, '0') + " - " + d?.razaoSocial + "
                                                - [ " + d?.cadMun?.municipio + "/" + d?.cadMun?.uf + " ]" }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cadCadastro'].hasError('required') && doctoCForm.controls['cadCadastro'].touched">
                                            Destinatário é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="35" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Nome</mat-label>
                                        <input [imask]="maskUpper" matInput type="text" formControlName="nome"
                                            (focus)="$event.target.select()">
                                        <mat-error
                                            *ngIf="doctoCForm.controls['nome'].hasError('required') && doctoCForm.controls['nome'].touched">
                                            Nome é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>CNPJ/CPF</mat-label>
                                        <input [imask]="maskUpper" matInput type="text" formControlName="cnpjCpf"
                                            (focus)="$event.target.select()">
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cnpjCpf'].hasError('required') && doctoCForm.controls['cnpjCpf'].touched">
                                            CNPJ/CPF é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="100" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Endereço de Faturamento</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadCadastroEndereco']"
                                            [compareWith]="compareById">
                                            <!-- nulo: cai no endereço padrão/cobrança do cadastro e,
                                                 sem nenhum deles, no endereço do próprio cadastro -->
                                            <mat-option [value]="null">
                                                {{ descricaoEnderecoFaturamento(null) }}
                                            </mat-option>
                                            <mat-option *ngFor="let e of enderecosFaturamento" [value]="e">
                                                {{ descricaoEnderecoFaturamento(e) }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint>Sem escolha, usa o endereço padrão do cadastro; sem endereço
                                            cadastrado, o endereço do próprio cliente/fornecedor.</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Condições -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Condições</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>{{ rotuloVendedor }}</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadVendedor']"
                                            (selectionChange)="onSelectionChangeVendedor($event)"
                                            (openedChange)="onSelectOpenedChange('searchVendedor', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchVendedor']"
                                                    placeholderLabel="Pesquisar Vendedor"
                                                    noEntriesFoundLabel="Vendedor não encontrado"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let vendedor of vendedores" [value]="vendedor">
                                                {{ vendedor?.codigo?.toString().padStart(9, '0') + " - " +
                                                vendedor?.razaoSocial }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['cadVendedor'].hasError('required') && doctoCForm.controls['cadVendedor'].touched">
                                            Vendedor é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Condição de Pagamento</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatCondPg']"
                                            (selectionChange)="onSelectionChangeCondPg($event)"
                                            (openedChange)="onSelectOpenedChange('searchCondPg', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchCondPg']"
                                                    placeholderLabel="Pesquisar Condição"
                                                    noEntriesFoundLabel="Condição não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let c of filteredCondpgs | async" [value]="c">
                                                {{ c?.codigo?.toString().padStart(5, '0') + " - " + c?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatCondPg'].hasError('required') && doctoCForm.controls['fatCondPg'].touched">
                                            Condição de Pagamento é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Lista de Preço</mat-label>
                                        <!-- compareWith: a lista resolvida chega como outro objeto (mesmo id);
                                             sem ele o select não reconhecia a troca ao escolher o cliente. -->
                                        <mat-select [formControl]="doctoCForm.controls['fatListaPreco']"
                                            [compareWith]="compareById"
                                            [disabled]="listaPrecoTravadaPeloCadastro || listaPrecoBloqueadaPorBaixa"
                                            (selectionChange)="onSelectionChangeListaPreco($event)"
                                            (openedChange)="onSelectOpenedChange('searchLisPre', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchLisPre']"
                                                    placeholderLabel="Pesquisar Lista"
                                                    noEntriesFoundLabel="Lista não encontrada"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let l of listaPrecos" [value]="l">
                                                {{ l?.codigo?.toString().padStart(5, '0') + " - " + l?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-icon matSuffix *ngIf="listaPrecoTravadaPeloCadastro || listaPrecoBloqueadaPorBaixa">lock</mat-icon>
                                        <mat-hint *ngIf="listaPrecoTravadaPeloCadastro">Lista e tabela do cadastro do cliente (exigidas pela transação)</mat-hint>
                                        <mat-hint *ngIf="listaPrecoBloqueadaPorBaixa && !listaPrecoTravadaPeloCadastro">Lançamento com baixa no financeiro</mat-hint>
                                        <mat-error
                                            *ngIf="doctoCForm.controls['fatListaPreco'].hasError('required') && doctoCForm.controls['fatListaPreco'].touched">
                                            Lista de Preço é obrigatória
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Tabela de Preço</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['fatListaPrecoTabela']"
                                            [compareWith]="tabelaIdComparaison"
                                            [disabled]="listaPrecoTravadaPeloCadastro || listaPrecoBloqueadaPorBaixa"
                                            (selectionChange)="onSelectionChangeTabelaPreco($event)">
                                            <mat-option *ngFor="let tabela of tabelas" [value]="tabela">
                                                {{ tabela?.id?.tabelaId?.toString() + " - " + tabela?.descricao }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Ordem de Serviço — mesmos campos da tela de OS do desktop (ordemServico.fxml):
                         veículo atendido e o apontamento de defeitos. Aparece quando a empresa tem o
                         módulo Serviços Mecânico, quando a transação é de OS (d122=4) ou quando o
                         documento já tem esses dados gravados. -->
                    <mat-card fxFlex="100" class="section-card" *ngIf="isOrdemServico">
                        <mat-card-title>Ordem de Serviço</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <div fxFlex="100" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Veículo</mat-label>
                                        <mat-select [formControl]="doctoCForm.controls['cadVeiculo']"
                                            [compareWith]="compareById"
                                            (selectionChange)="onSelectionChangeVeiculo($event)"
                                            (openedChange)="onSelectOpenedChange('searchVeiculo', $event)">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="doctoCForm.controls['searchVeiculo']"
                                                    placeholderLabel="Pesquisar Veículo (placa/descrição)"
                                                    noEntriesFoundLabel="Veículo não encontrado"
                                                    [searching]="searching"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option [value]="null">[ Sem veículo ]</mat-option>
                                            <mat-option *ngFor="let v of veiculos" [value]="v">
                                                {{ displayVeiculo(v) }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint>Veículo atendido nesta OS</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="48" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Defeito Reclamado</mat-label>
                                        <textarea matInput rows="5" formControlName="defeitoreclamado"
                                            placeholder="O que o cliente relatou"></textarea>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="48" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Defeito Constatado</mat-label>
                                        <textarea matInput rows="5" formControlName="defeitoconstatado"
                                            placeholder="O que a oficina constatou"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Dados NFS-e (Padrão Nacional) — só para série modelo 99 -->
                    <mat-card fxFlex="100" class="section-card" *ngIf="isNfseDocto">
                        <mat-card-title>Dados NFS-e (Padrão Nacional)</mat-card-title>
                        <mat-card-content>
                            <div formGroupName="nfse" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                                <!-- Retorno da SEFIN — somente leitura -->
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Situação</mat-label>
                                        <input matInput readonly [value]="nfseSituacaoDescricao"
                                            placeholder="Não emitida">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="45" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Chave de Acesso (50)</mat-label>
                                        <input matInput readonly formControlName="nfseChaveacesso">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Ambiente</mat-label>
                                        <input matInput readonly formControlName="nfseAmbiente">
                                    </mat-form-field>
                                </div>

                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Série DPS</mat-label>
                                        <input matInput readonly formControlName="nfseSerieDps">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Nº DPS</mat-label>
                                        <input matInput readonly formControlName="nfseNdps">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Competência</mat-label>
                                        <input matInput type="date" formControlName="nfseCompetencia">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Cód. Verificação</mat-label>
                                        <input matInput readonly formControlName="nfseCodVerificacao">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Protocolo</mat-label>
                                        <input matInput readonly formControlName="nfseProtocolo">
                                    </mat-form-field>
                                </div>

                                <!-- ISSQN — editáveis no lançamento -->
                                <div fxFlex="25" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Município de Incidência (IBGE)</mat-label>
                                        <input matInput maxlength="7" formControlName="nfseMunicipioIncidencia"
                                            placeholder="Município da filial quando em branco">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="30" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Regime Especial de Tributação</mat-label>
                                        <mat-select formControlName="nfseRegEspTrib">
                                            <mat-option *ngFor="let r of regimesEspeciaisTributacao" [value]="r.value">
                                                {{ r.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Alíquota ISS (%)</mat-label>
                                        <input matInput formControlName="nfseAliquotaIss" currencyMask [options]="{ prefix: '', suffix: ' %', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Base de Cálculo</mat-label>
                                        <input matInput formControlName="nfseBaseCalculo" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="10" fxFlex.lt-md="100" fxLayoutAlign="start center">
                                    <mat-checkbox formControlName="nfseIssRetido">ISS Retido</mat-checkbox>
                                </div>

                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Deduções</mat-label>
                                        <input matInput formControlName="nfseValorDeducoes" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Desconto Incondicional</mat-label>
                                        <input matInput formControlName="nfseDescIncond" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Desconto Condicional</mat-label>
                                        <input matInput formControlName="nfseDescCond" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>IR Retido</mat-label>
                                        <input matInput formControlName="nfseValorIr" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="15" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>CSLL Retida</mat-label>
                                        <input matInput formControlName="nfseValorCsll" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="20" fxFlex.lt-md="100">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Valor Líquido</mat-label>
                                        <input matInput readonly formControlName="nfseValorLiquido" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2, align: 'right', allowNegative: false }">
                                    </mat-form-field>
                                </div>

                                <!-- Motivo da rejeição/cancelamento -->
                                <div fxFlex="100" *ngIf="doctoCForm.get('nfse.nfseMotivo')?.value">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Motivo (SEFIN)</mat-label>
                                        <textarea matInput readonly rows="2"
                                            formControlName="nfseMotivo"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <!-- Dados Adicionais -->
                    <mat-card fxFlex="100" class="section-card">
                        <mat-card-title>Dados Adicionais</mat-card-title>
                        <mat-card-content>
                            <mat-tab-group mat-align-tabs="start">
                                <mat-tab label="Dados Adicionais">
                                    <div style="display:flex; align-items:center; gap:8px;">
                                        <label>Dados Adicionais</label>
                                        <button mat-icon-button type="button" color="primary"
                                            matTooltip="Consultar Texto Adicional"
                                            (click)="toggleTxtAddLookup('dadosadicionais')">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </div>
                                    <ng-container
                                        *ngIf="showTxtAddLookup && txtAddTargetField === 'dadosadicionais'"
                                        [ngTemplateOutlet]="txtAddLookupTpl"></ng-container>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <textarea matInput formControlName="dadosadicionais" rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                                <mat-tab label="Dados Adicionais - Fisco">
                                    <div style="display:flex; align-items:center; gap:8px;">
                                        <label>Dados Adicionais - Fisco</label>
                                        <button mat-icon-button type="button" color="primary"
                                            matTooltip="Consultar Texto Adicional"
                                            (click)="toggleTxtAddLookup('dadosadicionaiscontribuinte')">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </div>
                                    <ng-container
                                        *ngIf="showTxtAddLookup && txtAddTargetField === 'dadosadicionaiscontribuinte'"
                                        [ngTemplateOutlet]="txtAddLookupTpl"></ng-container>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <textarea matInput formControlName="dadosadicionaiscontribuinte"
                                            rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                                <mat-tab label="Outros Dados">
                                    <div style="display:flex; align-items:center; gap:8px;">
                                        <label>Outros Dados</label>
                                        <button mat-icon-button type="button" color="primary"
                                            matTooltip="Consultar Texto Adicional"
                                            (click)="toggleTxtAddLookup('outrosDados')">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                    </div>
                                    <ng-container
                                        *ngIf="showTxtAddLookup && txtAddTargetField === 'outrosDados'"
                                        [ngTemplateOutlet]="txtAddLookupTpl"></ng-container>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <textarea matInput formControlName="outrosDados" rows="4"></textarea>
                                    </mat-form-field>
                                </mat-tab>
                            </mat-tab-group>

                            <!-- Lookup Texto Adicional (mesmo layout do envio de WhatsApp) -->
                            <ng-template #txtAddLookupTpl>
                                <div class="txtadd-lookup-panel">
                                    <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
                                        <mat-form-field style="flex:1" appearance="outline">
                                            <mat-label>Pesquisar texto adicional</mat-label>
                                            <input matInput #txtAddInput [value]="txtAddSearch"
                                                (input)="onTxtAddSearchChange(txtAddInput.value)" autocomplete="off" />
                                        </mat-form-field>
                                        <button mat-icon-button type="button" color="warn" matTooltip="Fechar"
                                            (click)="showTxtAddLookup = false">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                    <div class="txtadd-lookup-list">
                                        <div *ngIf="txtAddLoading" style="text-align:center; padding:12px;">Carregando...
                                        </div>
                                        <div *ngIf="!txtAddLoading && txtAddResults.length === 0"
                                            style="text-align:center; padding:12px; color:#888;">
                                            Nenhum texto adicional encontrado
                                        </div>
                                        <table *ngIf="!txtAddLoading && txtAddResults.length > 0"
                                            class="txtadd-lookup-table">
                                            <thead>
                                                <tr>
                                                    <th style="width:60px">Código</th>
                                                    <th>Descrição</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of txtAddResults" (click)="selectTxtAdd(item)"
                                                    class="txtadd-lookup-row" matTooltip="{{ item.texto }}">
                                                    <td>{{ ((item.codigo ?? item.id) + '').padStart(5, '0') }}</td>
                                                    <td>{{ item.descricao }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </ng-template>
                        </mat-card-content>
                    </mat-card>

                    <!-- Total -->
                    <mat-card fxFlex="100" class="section-card" *ngIf="!layoutConf.isMobile">
                        <mat-card-title>Total</mat-card-title>
                        <mat-card-content>
                            <div fxLayout="row" fxLayoutAlign="end center">
                                <h1 *ngIf="!layoutConf.isMobile">TOTAL: {{ doctoCForm.controls['valortotalDocto'].value
                                    | currency:'BRL' }}</h1>
                                <h3 *ngIf="layoutConf.isMobile">TOTAL: {{ doctoCForm.controls['valortotalDocto'].value |
                                    currency:'BRL' }}</h3>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <!-- Botões Inferiores -->
        <mat-card-actions>
            <div fxFlex="100" class="action-buttons">
                <button mat-raised-button color="primary" [matTooltip]="'Salvar Lançamento'"
                    (click)="save(false, false); $event.preventDefault()">
                    <mat-icon>save</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
                </button>

                <button type="button" mat-raised-button color="accent" (click)="novoLcto(); $event.preventDefault()">
                    <mat-icon>add</mat-icon>
                    <ng-container *ngIf="!layoutConf.isMobile">Novo Lcto</ng-container>
                </button>
            </div>
        </mat-card-actions>
    </form>
</mat-card>